/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateContractAnnouncementRequest { 
    agreementDate?: string;
    publishedDate?: Date;
    deliveryDate?: Date;
    divisiblePurchase?: boolean;
    offerNumber?: number;
    maxOffer?: number;
    minOffer?: number;
    agreementValue?: number;
    estimatedPurchaseValue?: number;
    currency?: CreateContractAnnouncementRequest.CurrencyEnum;
    status?: string;
    url?: string;
    fileUrl?: string;
    description?: string;
    type?: CreateContractAnnouncementRequest.TypeEnum;
    other?: { [key: string]: any; };
    country?: CreateContractAnnouncementRequest.CountryEnum;
    contractNoticeId?: string;
    bidderIds?: Array<string>;
    contractorIds?: Array<string>;
    tagIds?: Array<string>;
}
export namespace CreateContractAnnouncementRequest {
    export type CurrencyEnum = 'MKD' | 'EUR' | 'USD' | 'ALL';
    export const CurrencyEnum = {
        MKD: 'MKD' as CurrencyEnum,
        EUR: 'EUR' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        ALL: 'ALL' as CurrencyEnum
    };
    export type TypeEnum = 'CONTRACT_AWARD' | 'CANCELLATION' | 'MODIFICATION' | 'LATEST_DECISION';
    export const TypeEnum = {
        CONTRACTAWARD: 'CONTRACT_AWARD' as TypeEnum,
        CANCELLATION: 'CANCELLATION' as TypeEnum,
        MODIFICATION: 'MODIFICATION' as TypeEnum,
        LATESTDECISION: 'LATEST_DECISION' as TypeEnum
    };
    export type CountryEnum = 'MK' | 'AL' | 'XK';
    export const CountryEnum = {
        MK: 'MK' as CountryEnum,
        AL: 'AL' as CountryEnum,
        XK: 'XK' as CountryEnum
    };
}